import { useEffect, useState } from 'react';

const MINUTE_MS = 60 * 1000;

/**
 * Re-renders the calling component once a minute while `enabled` is true, so
 * grace period countdowns ("starts in 31h") advance and pending UI disappears
 * once the role takes effect. Callers read the clock themselves during render.
 */
export function useMinuteTick(enabled: boolean) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const intervalId = window.setInterval(() => setTick((tick) => tick + 1), MINUTE_MS);
    return () => window.clearInterval(intervalId);
  }, [enabled]);
}
